module.exports = __webpack_public_path__ + "static/img/42-2.0b5d5a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/42-2.jpg
// module id = W2GT
// module chunks = 0